/**
 * Base WebSocket manager types
 * @module types/websocket
 */

import type { LoggerConfig, AnalyticsConfig } from './common';

/**
 * Configuration for the base WebSocket manager
 */
export interface WebSocketManagerConfig {
  /** Interval in ms between reconnection attempts (default: 2000) */
  reconnectInterval?: number;
  /** Maximum number of reconnection attempts, -1 for unlimited (default: 5) */
  maxReconnectAttempts?: number;
  /** Logger configuration */
  logger?: LoggerConfig;
  /** Analytics configuration */
  analytics?: AnalyticsConfig;
}

/**
 * WebSocket client type identifier
 */
export enum WebSocketClientType {
  PRICES = 'PRICES',
  TRADES = 'TRADES',
  US_PRICES = 'US_PRICES',
}

/**
 * Callback for WebSocket connection state changes
 */
export type ConnectionCallback = (
  ws: WebSocket | null,
  client: WebSocketClientType | string,
) => void;
